module.exports = __webpack_public_path__ + "static/media/nike-there-will-be-goals.f6a7bb4e.jpg";